<irembogov-tin-input
  [formControl]="formControl"
  [id]="field.key"
  [placeholder]="field.props['placeholder']"
  [tinLength]="tinLength"
  [statusClass]="statusClass"
  [isReadonly]="field.props.readonly || isReadonly"
  (verifyTin)="onVerifyTin($event)"></irembogov-tin-input>
